import _ from "lodash";
import moment from "moment";
import html2canvas from "html2canvas";
import $ from "jquery";
import { FacebookShareButton, LinkedinShareButton } from "react-share";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { shareImage } from "../../redux/events/actions";
import { capitalizeFirstLetter, ProductCardPriceInfo, SessionKeys } from "../../utils/AppUtils";
import CONFIG from "../../utils/config";
import useLogin from "../../custom-hooks/useLogin";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";

const EventSessionDetailComponent = (props) => {
  const {
    selectedSession,
    renderButton,
    setDeliveryMode,
    setIsLoading,
    setClickedShareBtn,
    setClickDetailShareBtn,
    isLearn,
    isLive,
    isEvents,
    renderViewMore,
    isCoaching,
    renderCoachingButtons,
    isMyCoaching
  } = props;
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const isGuest = params.get("guest");
  const { isLoggedIn } = useLogin();
  const { t } = useTranslation();
  const imageUrlRes = useSelector((state) => state.events.shareImageRes);
  const userRole = useSelector((state) => state.user.role);
  const authBroker = useSelector((state) => state.auth.authBroker);

  const dispatch = useDispatch();
  const [shareClicked, setshareClicked] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [fbTagetUrl, setfbTagetUrl] = useState();
  const [linkedinTargetUrl, setlinkedinTargetUrl] = useState();

  // useEffect(() => {

  //     if(shareClicked)
  //     {
  //         console.log("image clicked")
  //         getBlob();
  //        setshareClicked(false);
  //     }

  // }, [shareClicked]);

  useEffect(() => {
    if (imageUrlRes?.status === "success") {
      setfbTagetUrl(imageUrlRes?.payload?.payload?.fb_target_url);
      setlinkedinTargetUrl(imageUrlRes?.payload?.payload?.linkedin_target_url);
      setIsLoading(false);
      console.log(
        "image url",
        CONFIG.API_URL_BROKER_ADMIN + imageUrlRes?.payload?.payload
      );
    }
  }, [imageUrlRes, dispatch]);

  useEffect(() => { }, [imageUrl]);

  const currentRef = useRef(null);

  const getBlob = () => {
    const htmlContent = currentRef.current.innerHTML;
    const currentDate = new Date();
    // Convert to epoch (Unix timestamp)
    const epochTime = Math.floor(currentDate.getTime() / 1000); // Divide by 1000 to get seconds
    const formattedTime = `${epochTime}`;
    setshareClicked(true);
    setIsLoading(true);
    dispatch(
      shareImage({
        module: "shareImage",
        postData: {
          image_name: formattedTime,
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          content: htmlContent,
        },
      })
    );
  };
  return (
    <section>
      {!_.isEmpty(selectedSession) && (
        <div className="section-detail-event" ref={currentRef}>
          {false && (
            <div className="event-detail-header">
              {isLearn || isLive || isGuest
                ? ""
                : !isGuest &&
                isLoggedIn &&
                userRole !== "customer" && (
                  <div class="sm_list">
                    <a href="#" class="linkedin">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        onClick={() => {
                          setClickedShareBtn(1);
                          setClickDetailShareBtn(true);
                          // window.open(pdfUrl, "_blank")
                        }}
                      >
                        <defs>
                          <linearGradient
                            id="linear-gradientnotes"
                            x2="1"
                            y1="0.5"
                            y2="0.5"
                            gradientUnits="objectBoundingBox"
                          >
                            <stop offset="0" stopColor="#415385"></stop>
                            <stop offset="1" stopColor="#415385"></stop>
                          </linearGradient>
                        </defs>
                        <circle
                          cx="15"
                          cy="15"
                          r="15"
                          fill="url(#linear-gradientnotes)"
                          data-name="Ellipse 180"
                        ></circle>
                        <circle
                          cx="13"
                          cy="13"
                          r="13"
                          fill="#fff"
                          data-name="Ellipse 181"
                          transform="translate(2 2)"
                        ></circle>
                        <path
                          fill="#415385"
                          d="M5.684 8a3.015 3.015 0 01-.062-1.466c.262.003.237 1.157.062 1.466zm-.053 1.478a14.42 14.42 0 01-.887 1.959 11.507 11.507 0 011.966-.684 4.048 4.048 0 01-1.079-1.275zm-2.941 3.9c0 .025.412-.169 1.091-1.256a4.319 4.319 0 00-1.09 1.256zM7.75 5H12v10.25a.748.748 0 01-.75.75H.75a.748.748 0 01-.75-.75V.75A.748.748 0 01.75 0H7v4.25a.752.752 0 00.75.75zm-.25 5.369a3.136 3.136 0 01-1.334-1.681 4.492 4.492 0 00.194-2.006.783.783 0 00-1.494-.213 5.2 5.2 0 00.253 2.406 29.344 29.344 0 01-1.275 2.681h-.006c-.847.434-2.3 1.391-1.7 2.125a.971.971 0 00.668.319c.559 0 1.116-.562 1.909-1.931a17.813 17.813 0 012.469-.725 4.736 4.736 0 002 .609.809.809 0 00.616-1.359c-.434-.425-1.7-.3-2.3-.225zm4.281-7.087L8.719.219A.749.749 0 008.188 0H8v4h4v-.191a.748.748 0 00-.219-.528zm-2.315 7.977c.128-.084-.078-.372-1.338-.281 1.16.494 1.338.281 1.338.281z"
                          data-name="Icon awesome-file-pdf"
                          transform="translate(9 7)"
                        ></path>
                      </svg>
                    </a>
                    <a href="#" class="linkedin">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        onClick={() => {
                          setClickedShareBtn(2);
                          setClickDetailShareBtn(true);
                          // window.open(imageUrl, "_blank")
                        }}
                      >
                        <defs>
                          <linearGradient
                            id="linear-gradient"
                            y1="0.5"
                            x2="1"
                            y2="0.5"
                            gradientUnits="objectBoundingBox"
                          >
                            <stop offset="0" stopColor="#415385"></stop>
                            <stop offset="1" stopColor="#415385"></stop>
                          </linearGradient>
                        </defs>
                        <circle
                          id="Ellipse_57"
                          data-name="Ellipse 57"
                          cx="15"
                          cy="15"
                          r="15"
                          fill="url(#linear-gradient)"
                        ></circle>
                        <circle
                          id="Ellipse_179"
                          data-name="Ellipse 179"
                          cx="13"
                          cy="13"
                          r="13"
                          transform="translate(2 2)"
                          fill="#fff"
                        ></circle>
                        <g
                          id="surface1"
                          className="imageuploadsv"
                          transform="translate(5 4.586)"
                        >
                          <path
                            fill="#415385"
                            stroke="#415385"
                            d="M 3.332031 3.332031 C 2.421875 3.332031 1.667969 4.089844 1.667969 5 L 1.667969 15 C 1.667969 15.910156 2.421875 16.667969 3.332031 16.667969 L 16.667969 16.667969 C 17.578125 16.667969 18.332031 15.910156 18.332031 15 L 18.332031 5 C 18.332031 4.089844 17.578125 3.332031 16.667969 3.332031 Z M 3.332031 5 L 16.667969 5 L 16.667969 15 L 3.332031 15 Z M 12.082031 9.167969 L 9.167969 12.5 L 7.082031 10.417969 L 4.816406 13.332031 L 15.207031 13.332031 Z M 12.082031 9.167969 "
                          />
                        </g>
                      </svg>
                    </a>
                    <a href="#" class="facebook">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        id="facebook"
                        data-name="facebook"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        onClick={() => {
                          setClickedShareBtn(3);
                          setClickDetailShareBtn(true);
                          //  window.open(fbTagetUrl, "_blank")
                        }}
                      >
                        <defs>
                          <linearGradient
                            id="linear-gradients"
                            y1="0.5"
                            x2="1"
                            y2="0.5"
                            gradientUnits="objectBoundingBox"
                          >
                            <stop offset="0" stop-color="#415385" />
                            <stop offset="1" stop-color="#415385" />
                          </linearGradient>
                        </defs>
                        <circle
                          id="Ellipse_198"
                          data-name="Ellipse 198"
                          cx="15"
                          cy="15"
                          r="15"
                          fill="url(#linear-gradients)"
                        />
                        <circle
                          id="Ellipse_199"
                          data-name="Ellipse 199"
                          cx="13"
                          cy="13"
                          r="13"
                          transform="translate(2 2)"
                          fill="#fff"
                          className="fillwhite"
                        />
                        <path
                          id="Icon_awesome-facebook-f"
                          data-name="Icon awesome-facebook-f"
                          d="M8.9,8.2l.4-2.638H6.778V3.849A1.319,1.319,0,0,1,8.265,2.424H9.415V.178A14.031,14.031,0,0,0,7.373,0,3.22,3.22,0,0,0,3.926,3.55V5.56H1.609V8.2H3.926v6.376H6.778V8.2Z"
                          transform="translate(9.487 7.713)"
                          fill="#415385"
                        />
                      </svg>
                    </a>
                    <a href="#" class="linkedin">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        id="linkedin"
                        data-name="linkedin"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        onClick={() => {
                          setClickedShareBtn(4);
                          setClickDetailShareBtn(true);
                          // window.open(linkedinTargetUrl, "_blank")
                        }}
                      >
                        <defs>
                          <linearGradient
                            id="linear-gradients"
                            y1="0.5"
                            x2="1"
                            y2="0.5"
                            gradientUnits="objectBoundingBox"
                          >
                            <stop offset="0" stop-color="#415385" />
                            <stop offset="1" stop-color="#415385" />
                          </linearGradient>
                        </defs>
                        <circle
                          id="Ellipse_57"
                          data-name="Ellipse 57"
                          cx="15"
                          cy="15"
                          r="15"
                          fill="url(#linear-gradients)"
                        />
                        <circle
                          id="Ellipse_179"
                          data-name="Ellipse 179"
                          cx="13"
                          cy="13"
                          r="13"
                          transform="translate(2 2)"
                          fill="#fff"
                          className="fillwhite"
                        />
                        <path
                          id="Icon_awesome-linkedin-in"
                          data-name="Icon awesome-linkedin-in"
                          d="M2.781,12.424H.205V4.13H2.781ZM1.492,3A1.5,1.5,0,1,1,2.983,1.492,1.5,1.5,0,0,1,1.492,3Zm10.929,9.426H9.851V8.386c0-.962-.019-2.2-1.339-2.2-1.339,0-1.544,1.045-1.544,2.127v4.107H4.394V4.13h2.47V5.261H6.9A2.706,2.706,0,0,1,9.338,3.922c2.607,0,3.086,1.717,3.086,3.946v4.556Z"
                          transform="translate(8.788 8.789)"
                          fill="#415385"
                        />
                      </svg>
                    </a>
                  </div>
                )}
              <div class="events-section-detail">
                <div class="date-box">
                  <strong>{moment(selectedSession?.start).format("DD")}</strong>
                  {moment(selectedSession?.start).format("MMM")}
                </div>
                <div class="events-title-box">
                  <div class="events-tilte">
                    <strong>
                      {selectedSession?.title}{" "}
                      {selectedSession?.kickoff_session === "1" && !isEvents
                        ? `(Kickoff Session)`
                        : ""}
                    </strong>
                  </div>
                  <div class="date-box-events">
                    {moment(selectedSession?.start).format("ddd, h:mm A")}{" "}
                    {selectedSession?.timezone} |{" "}
                    {setDeliveryMode(selectedSession)}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="event-detail-body">
            <div className="event-img">
              <img
                src={
                  !_.isEmpty(selectedSession?.marketting_event_banner)
                    ? selectedSession?.marketting_event_banner
                    : "/images/image19.png"
                }
                className="img-fluid"
                alt=""
              />
            </div>
            <div className="event-details">
              <div className="d-flex justify-content-between gap-2 ttile-cj flex-column">
                <div className="headevent">
                  {selectedSession?.title}{" "}
                  {selectedSession?.kickoff_session === "1" && !isEvents
                    ? `(Kickoff Session)`
                    : ""}
                </div>
                {false && (
                  <Dropdown className="customdropdown-btn">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <svg
                        width="31"
                        height="32"
                        viewBox="0 0 31 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="30.5738"
                          y="31.0738"
                          width="30.1474"
                          height="30.1475"
                          rx="15.0737"
                          transform="rotate(180 30.5738 31.0738)"
                          fill="white"
                          stroke="#415385"
                          stroke-width="0.852453"
                        />
                        <circle
                          cx="15.4969"
                          cy="9.79999"
                          r="1.54999"
                          transform="rotate(90 15.4969 9.79999)"
                          fill="#415385"
                        />
                        <circle
                          cx="15.4969"
                          cy="22.2023"
                          r="1.54999"
                          transform="rotate(90 15.4969 22.2023)"
                          fill="#415385"
                        />
                        <circle
                          cx="15.4969"
                          cy="16.0031"
                          r="1.54999"
                          transform="rotate(90 15.4969 16.0031)"
                          fill="#415385"
                        />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <div className="list-drop reset-btn like-btn d-flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="#ff2600"
                            d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                          />
                        </svg>
                        Like
                      </div>
                      <div className="list-drop">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7625 15.025 18.6375C15.0417 18.5125 15.0667 18.4 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.6458 7.1 14.7875C6.75 14.9292 6.38333 15 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.07083 7.1 9.2125C7.45 9.35417 7.76667 9.55 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.4875 15.025 5.3625C15.0083 5.2375 15 5.11667 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92917 16.9 7.7875C16.55 7.64583 16.2333 7.45 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5125 8.975 11.6375C8.99167 11.7625 9 11.8833 9 12C9 12.1167 8.99167 12.2375 8.975 12.3625C8.95833 12.4875 8.93333 12.6 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3542 16.9 16.2125C17.25 16.0708 17.6167 16 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22ZM18 6C18.2833 6 18.5208 5.90417 18.7125 5.7125C18.9042 5.52083 19 5.28333 19 5C19 4.71667 18.9042 4.47917 18.7125 4.2875C18.5208 4.09583 18.2833 4 18 4C17.7167 4 17.4792 4.09583 17.2875 4.2875C17.0958 4.47917 17 4.71667 17 5C17 5.28333 17.0958 5.52083 17.2875 5.7125C17.4792 5.90417 17.7167 6 18 6ZM6 13C6.28333 13 6.52083 12.9042 6.7125 12.7125C6.90417 12.5208 7 12.2833 7 12C7 11.7167 6.90417 11.4792 6.7125 11.2875C6.52083 11.0958 6.28333 11 6 11C5.71667 11 5.47917 11.0958 5.2875 11.2875C5.09583 11.4792 5 11.7167 5 12C5 12.2833 5.09583 12.5208 5.2875 12.7125C5.47917 12.9042 5.71667 13 6 13ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19C19 18.7167 18.9042 18.4792 18.7125 18.2875C18.5208 18.0958 18.2833 18 18 18C17.7167 18 17.4792 18.0958 17.2875 18.2875C17.0958 18.4792 17 18.7167 17 19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20Z"
                            fill="black"
                          />
                        </svg>{" "}
                        Share
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
                {!isMyCoaching &&
                  <div>
                    <strong>{isEvents ? t("event") : t("workshop")}:</strong> <span>{selectedSession?.eventName}</span>
                  </div>}
              </div>

              <div className="timedate-box">
                <div className="timevalue">
                  {moment(selectedSession?.start).format("hh:mm A")}
                  {/* A to AM/PM */}
                </div>
                <div className="venue-vlau">
                  <div className="dayval">
                    {moment(selectedSession?.start, "MM/DD/YYYY").format(
                      "dddd, Do MMM YYYY"
                    )} ({selectedSession.userTimezone})
                  </div>
                  <div className="venueval">
                    {/* {selectedSession.delivery_mode === "blended_session" ? (
                      <>
                        {"In-Person/Virtual (" + selectedSession.location + ")"}
                      </>
                    ) : selectedSession.delivery_mode === "face_to_face" ? (
                      <>{"In-Person (" + selectedSession.location + ")"}</>
                    ) : selectedSession.delivery_mode ===
                        "virtual_interactive" ||
                      selectedSession.delivery_mode === "virtual_broadcast" ? (
                      "Virtual"
                    ) : (
                      "Live"
                    )} */}{" "}
                    {isMyCoaching ? 'Online' : (!isEvents ? (
                      capitalizeFirstLetter(selectedSession.sessionMode)
                    ) : selectedSession.delivery_mode === "blended_session" ? (
                      <>
                        {"In-Person/Virtual (" + selectedSession.location + ")"}
                      </>
                    ) : selectedSession.delivery_mode === "face_to_face" ? (
                      <>{"In-Person (" + selectedSession.location + ")"}</>
                    ) : selectedSession.delivery_mode ===
                      "virtual_interactive" ||
                      selectedSession.delivery_mode === "virtual_broadcast" ? (
                      "Virtual"
                    ) : (
                      "Live"
                    ))}
                  </div>
                </div>
              </div>
              {selectedSession?.language && <div className="trainer-box mb-3">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div className="img-box-ecclipse">
                    <strong>Language: </strong>
                  </div>
                  <div className="tect-vx">
                    {selectedSession?.language}
                  </div>
                </div>
              </div>}
              {selectedSession?.sessionMode?.toLowerCase() === "onsite" && <div className="trainer-box mb-3">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div className="img-box-ecclipse">
                    <strong>Location: </strong>
                  </div>
                  <div className="tect-vx">
                    {selectedSession?.location}
                  </div>
                </div>
              </div>}
              <div className="trainer-box mb-3">
                <p className="mb-2">
                  <strong>
                    {isMyCoaching ? t('Coach') : t('trainer')}
                    {selectedSession?.author?.length > 1 ? "s" : ""}{" "}
                    {selectedSession?.author?.length > 1
                      ? `(${selectedSession?.author?.length})`
                      : ""}
                  </strong>
                </p>

                {!_.isEmpty(selectedSession?.author) &&
                  selectedSession?.author?.map((item) => {
                    return (
                      <>
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <div className="img-box-ecclipse">
                            <img
                              src={
                                item?.profile_image
                                  ? item?.profile_image
                                  : "/images/avatar.svg" //"/images/get_certified02.jpg"
                              }
                              className="imgbx"
                              alt=""
                            />
                          </div>
                          <div className="tect-vx">
                            <strong>{item?.name}</strong>
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
              {/* <ul className='even-detail-list'>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M10 18.3334C5.39763 18.3334 1.66667 14.6024 1.66667 10.0001C1.66667 5.39771 5.39763 1.66675 10 1.66675C14.6023 1.66675 18.3333 5.39771 18.3333 10.0001C18.3333 14.6024 14.6023 18.3334 10 18.3334ZM10.8333 10.0001V5.83341H9.16667V11.6667H14.1667V10.0001H10.8333Z" fill="#415385" />
                </svg>
                <span className='text-ec'>{moment(selectedSession?.start).format('DD MMM, ddd h:mm A') + " - " + moment(selectedSession?.end).format('h:mm A')} {selectedSession?.timezone}</span>

              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M15.3033 14.4701L10 19.7733L4.6967 14.4701C1.76777 11.5411 1.76777 6.79238 4.6967 3.86345C7.62563 0.934515 12.3743 0.934515 15.3033 3.86345C18.2323 6.79238 18.2323 11.5411 15.3033 14.4701ZM10 12.5001C11.8409 12.5001 13.3333 11.0077 13.3333 9.16675C13.3333 7.3258 11.8409 5.83341 10 5.83341C8.15905 5.83341 6.66667 7.3258 6.66667 9.16675C6.66667 11.0077 8.15905 12.5001 10 12.5001ZM10 10.8334C9.0795 10.8334 8.33333 10.0872 8.33333 9.16675C8.33333 8.24627 9.0795 7.50008 10 7.50008C10.9205 7.50008 11.6667 8.24627 11.6667 9.16675C11.6667 10.0872 10.9205 10.8334 10 10.8334Z" fill="#415385" />
                </svg>
                <span className='text-ec'>{selectedSession.delivery_mode === "blended_session" ? <>{"In-Person/Virtual (" + selectedSession.location + ")"}</> : selectedSession.delivery_mode === "face_to_face" ? <>{"In-Person (" + selectedSession.location + ")"}</> : selectedSession.delivery_mode === "virtual_interactive" || selectedSession.delivery_mode === "virtual_broadcast" ? "Virtual" : "Live"}</span>
              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M2.5 4.16258C2.5 3.24436 3.24385 2.5 4.16258 2.5H15.8374C16.7557 2.5 17.5 3.24385 17.5 4.16258V15.8374C17.5 16.7557 16.7562 17.5 15.8374 17.5H4.16258C3.24436 17.5 2.5 16.7562 2.5 15.8374V4.16258ZM5.29739 15H14.8729C13.8187 13.4887 12.0674 12.5 10.0852 12.5C8.10287 12.5 6.35152 13.4887 5.29739 15ZM10 10.8333C11.6108 10.8333 12.9167 9.5275 12.9167 7.91667C12.9167 6.30583 11.6108 5 10 5C8.38917 5 7.08333 6.30583 7.08333 7.91667C7.08333 9.5275 8.38917 10.8333 10 10.8333Z" fill="#415385" />
                </svg>
                <span className='text-ec'>{selectedSession?.author}</span>
              </li>
            </ul> */}
              <div
                className="event-disc"
                dangerouslySetInnerHTML={{
                  __html: selectedSession?.marketting_event_desc,
                }}
              ></div>

              <div className="btn-details d-flex justify-content-end gap-3">
                {/* {!isGuest && <span className="popover-price">
                {!_.isEmpty(selectedSession.purchased_info) ? selectedSession.session_status === 0 && !selectedSession.purchased_info?.isPurchased && !selectedSession.purchased_info?.isFree ? "" :
                  ProductCardPriceInfo(
                    selectedSession.purchased_info.showText,
                    selectedSession.purchased_info.textColor
                  ) : ""}
              </span>} */}
                {/* <div className="d-flex gap-3 align-items-center">
                  
                   <button class="startcourse-btn acceptbtn">{t("Accept")}</button>
                </div> */}
                {/* {renderButton(selectedSession)} */}
                {!isCoaching ? renderButton(selectedSession) : renderCoachingButtons(selectedSession)}
                {isCoaching && false
                  && renderViewMore(selectedSession)}
                {/* <button class="btn-primary reviewbtn guidebtn rpsubmitbtn d-flex gap-1 align-items-center">View More</button> */}
                {/*<button class="btn-primary reviewbtn guidebtn rpsubmitbtn d-flex gap-1 align-items-center">Register</button>*/}
              </div>
            </div>

            {(fbTagetUrl || linkedinTargetUrl) && shareClicked ? (
              <div className="popup show">
                <header>
                  <div className="close" onClick={() => setshareClicked(false)}>
                    <i className="fa fa-times"></i>
                  </div>
                </header>
                <div className="content">
                  <p>Share this link via</p>
                  <ul className="icons">
                    {/* <FacebookShareButton
                              url={imageUrl }
                            > */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      id="facebook"
                      data-name="facebook"
                      width="26"
                      height="26"
                      viewBox="0 0 30 30"
                      onClick={() => window.open(fbTagetUrl, "_blank")}
                    >
                      <defs>
                        <linearGradient
                          id="linear-gradients"
                          y1="0.5"
                          x2="1"
                          y2="0.5"
                          gradientUnits="objectBoundingBox"
                        >
                          <stop offset="0" stop-color="#415385" />
                          <stop offset="1" stop-color="#415385" />
                        </linearGradient>
                      </defs>
                      <circle
                        id="Ellipse_198"
                        data-name="Ellipse 198"
                        cx="15"
                        cy="15"
                        r="15"
                        fill="url(#linear-gradients)"
                      />
                      <circle
                        id="Ellipse_199"
                        data-name="Ellipse 199"
                        cx="13"
                        cy="13"
                        r="13"
                        transform="translate(2 2)"
                        fill="#fff"
                        className="fillwhite"
                      />
                      <path
                        id="Icon_awesome-facebook-f"
                        data-name="Icon awesome-facebook-f"
                        d="M8.9,8.2l.4-2.638H6.778V3.849A1.319,1.319,0,0,1,8.265,2.424H9.415V.178A14.031,14.031,0,0,0,7.373,0,3.22,3.22,0,0,0,3.926,3.55V5.56H1.609V8.2H3.926v6.376H6.778V8.2Z"
                        transform="translate(9.487 7.713)"
                        fill="#415385"
                      />
                    </svg>
                    {/* </FacebookShareButton>
                            <LinkedinShareButton url={imageUrl }> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      id="linkedin"
                      data-name="linkedin"
                      width="26"
                      height="26"
                      viewBox="0 0 30 30"
                      onClick={() => window.open(linkedinTargetUrl, "_blank")}
                    >
                      <defs>
                        <linearGradient
                          id="linear-gradients"
                          y1="0.5"
                          x2="1"
                          y2="0.5"
                          gradientUnits="objectBoundingBox"
                        >
                          <stop offset="0" stop-color="#415385" />
                          <stop offset="1" stop-color="#415385" />
                        </linearGradient>
                      </defs>
                      <circle
                        id="Ellipse_57"
                        data-name="Ellipse 57"
                        cx="15"
                        cy="15"
                        r="15"
                        fill="url(#linear-gradients)"
                      />
                      <circle
                        id="Ellipse_179"
                        data-name="Ellipse 179"
                        cx="13"
                        cy="13"
                        r="13"
                        transform="translate(2 2)"
                        fill="#fff"
                        className="fillwhite"
                      />
                      <path
                        id="Icon_awesome-linkedin-in"
                        data-name="Icon awesome-linkedin-in"
                        d="M2.781,12.424H.205V4.13H2.781ZM1.492,3A1.5,1.5,0,1,1,2.983,1.492,1.5,1.5,0,0,1,1.492,3Zm10.929,9.426H9.851V8.386c0-.962-.019-2.2-1.339-2.2-1.339,0-1.544,1.045-1.544,2.127v4.107H4.394V4.13h2.47V5.261H6.9A2.706,2.706,0,0,1,9.338,3.922c2.607,0,3.086,1.717,3.086,3.946v4.556Z"
                        transform="translate(8.788 8.789)"
                        fill="#415385"
                      />
                    </svg>
                    {/* </LinkedinShareButton> */}
                  </ul>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default EventSessionDetailComponent;
